import { useRef, useState } from 'react'
import PlayIcon from '@/CustomIcons/PlayIcon'
import { Button } from '@/UIComponents2/Button'

type SettingsTutorialProps = {
    coverImageUrl: string
    source?: string
    sourceType?: string
    title: string
}
export function Tutorial(props: SettingsTutorialProps) {
    const videoRef = useRef<HTMLVideoElement>(null)
    const [isPlaying, setIsPlaying] = useState(false)

    const handlePlay = () => {
        const video = videoRef.current
        if (!video) return

        if (video.paused) {
            video.play()
            setIsPlaying(true)
        } else {
            video.pause()
            setIsPlaying(false)
        }
    }
    return (
        <Button
            className="relative w-full bg-cover aspect-7/6 rounded-[26px] group overflow-clip"
            style={{ backgroundImage: `url(${props.coverImageUrl})` }}
            onClick={handlePlay}
        >
            <video poster={props.coverImageUrl} className="w-full h-full object-cover" ref={videoRef} loop>
                <source src={props.source} type={props.sourceType} />
            </video>
            {!isPlaying && (
                <div className="absolute top-4 right-4 border-[2px] border-white rounded-full opacity-75 group-hover:opacity-100 bg-neutral-800">
                    <PlayIcon style={{ fontSize: '2.0rem' }} />
                </div>
            )}
            {!isPlaying && (
                <div className="absolute bottom-0 left-0 right-0 h-[100px] rounded-b-[26px] bg-gradient-to-b from-transparent via-[hsl(0deg_0%_10%/0.6)] to-[hsl(0deg_0%_10%/1.0)] flex items-end p-6">
                    <span className="t-lg-medium opacity-75 group-hover:opacity-100">{props.title}</span>
                </div>
            )}
        </Button>
    )
}
